import React from "react";
import { IonChip } from "@ionic/react";

interface EntryStatusChipProps {
    isComplete: boolean;
    completeLabel?: string;
    incompleteLabel?: string;
}

/** Collapsed-header status chip shared by entry subcards. */
const EntryStatusChip: React.FC<EntryStatusChipProps> = ({
    isComplete,
    completeLabel = "Complete",
    incompleteLabel = "Incomplete",
}) => {
    return (
        <IonChip className={`m-0 rounded-2 text-white font-weight-bold ${isComplete ? "bg-success" : "bg-warning"}`}>
            {isComplete ? completeLabel : incompleteLabel}
        </IonChip>
    );
};

export default EntryStatusChip;
